import OperationalStatus from './OperationalStatus';

export default {
  OperationalStatus,
};
